/**
 *  @class
 *  @function RemoveAll
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }

    triggerRemoveFromCartEvents() {
      // Find all cart items with remove buttons and trigger their remove_from_cart events
      const cartItems = this.drawer.querySelectorAll('[data-cart_item="true"]');
      
      cartItems.forEach(item => {
        const itemId = item.getAttribute('datalayer-item-id');
        if (!itemId) return;

        let origin = window.getProductOrigin ? window.getProductOrigin(itemId) : { item_list_id: ' ', item_list_name: ' ' };
        
        // If origin data is absent, try to get from element attributes
        if (origin.item_list_id === ' ' && origin.item_list_name === ' ') {
          const listId = item.getAttribute('datalayer-item_list_id') || ' ';
          const listName = item.getAttribute('datalayer-item_list_name') || ' ';
          
          if (window.getProductOrigin) {
            const stored = JSON.parse(localStorage.getItem('hp_product_origin_map') || '{}');
            if (!stored[itemId]) {
              stored[itemId] = { item_list_id: listId, item_list_name: listName };
              localStorage.setItem('hp_product_origin_map', JSON.stringify(stored));
            }
          }
          
          origin = { item_list_id: listId, item_list_name: listName };
        }

        const priceRaw = item.getAttribute('data-product_price');
        const price = parseFloat(priceRaw?.replace(',', '.') || 0);
        const quantity = parseInt(item.getAttribute('datalayer-quantity') || 1);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "remove_from_cart",
          ecommerce: {
            currency: "TRY",
            value: price * quantity,
            items: [{
              item_id: item.getAttribute('datalayer-item-id'),
              dimension15: item.getAttribute('datalayer-dimension15'),
              dimension14: item.getAttribute('datalayer-dimension14'),
              item_name: item.getAttribute('datalayer-item_name'),
              item_brand: item.getAttribute('datalayer-item_brand'),
              item_category: item.getAttribute('datalayer-item_category'),
              item_category2: item.getAttribute('datalayer-item_category2'),
              item_category3: item.getAttribute('datalayer-item_category3'),
              item_list_id: origin.item_list_id,
              item_list_name: origin.item_list_name,
              index: parseInt(item.getAttribute('datalayer-index'), 10),
              item_variant: item.getAttribute('datalayer-item_variant'),
              price: price,
              discount: parseFloat(item.getAttribute('datalayer-discount')?.replace(',', '.') || 0),
              quantity: quantity,
              dimension10: item.getAttribute('datalayer-dimension10'),
              dimension17: item.getAttribute('datalayer-dimension17'),
              dimension11: item.getAttribute('datalayer-dimension11'),
              Label_riskli_stok: item.getAttribute('datalayer-label_riskli_stok'),
              dimension16: parseFloat(item.getAttribute('datalayer-dimension16')?.replace(',', '.') || 0),
              dimension12: item.getAttribute('datalayer-dimension12')
            }]
          }
        });
      });
    }
    
    onSubmitHandler() {
      this.classList.add('loading');
      
      // Trigger remove_from_cart events for all items before clearing
      this.triggerRemoveFromCartEvents();
      
      fetch(`${theme.routes.cart_clear_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes')?.value
        })
      }).then(() => {
        this.classList.remove('loading');
        this.drawer.refresh();
      });
    }
  }
  customElements.define('remove-all', RemoveAll);
}